import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 55770606-AFB4-441F-B3AA-2CDE46136F4B
 * name format-annotation-minus
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-annotation-minus.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatAnnotationMinusIcon = createSvgIcon(<><path d="M10.5,7H8.5L3,21H5.2L6.3,18H12.5L13.6,21H16L10.5,7M7.1,16L9.5,9.7L11.9,16H7.1M22,7H14V5H22V7Z" /></>, 'FormatAnnotationMinusIcon');
export default FormatAnnotationMinusIcon